if (window.location.href.indexOf("/products/package-protection") > -1){
    window.location.replace("https://www.apeloigcollection.com/");
};

if (window.location.href.indexOf("gift-wrapping") > -1){
    window.location.replace("https://www.apeloigcollection.com/");
};

if (window.location.href.indexOf("gift-microsuede-challah-dough-cloth") > -1){
    window.location.replace("/");
};

if (window.location.href.indexOf("gift-set-microsuede-challah-dough-cloths") > -1){
    window.location.replace("/");
};



/* Script Load Cart */

$('.open-cart-rebuy').click(function() {
  cartLoad();
});

function cartLoad(){
  if (typeof Rebuy === 'undefined' || typeof Rebuy.SmartCart === 'undefined' || typeof Rebuy.SmartCart.show !== 'function') {
    RebuyPreload();
  } else {
    Rebuy.SmartCart.show();
  };
};

function RebuyPreload(){
  $('body').addClass('show-cart-preload');
};

function cartReady(){
  if ($('body').hasClass('show-cart-preload')) {
    setTimeout(function() {
      $('body').removeClass('show-cart-preload');
      Rebuy.SmartCart.show();
    }, 1000);
  };

  $('div#rebuy-cart .rebuy-cart__flyout-recommendations').prepend('<div data-rebuy-id="205439"></div>');
};


/* Script Notes Rebuy */

function giftWrapping(){
  $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations').before(
    '<div class="rebuy-cart__flyout-gift">' +
      '<div class="message-success-gift">' +
        '<span><i class="fa-solid fa-circle-check"></i> Added Gift Wrapping</span>' +
      '</div>' +
      '<div class="rebuy-cart__gift-container">' +
        '<label for="gift-with-purchase-rebuy">' +
          '<div class="rebuy-cart__gift-message">' +
            '<span>Is This a Gift?</span>' +
          '</div>' +
          '<div class="rebuy-cart__gift-input">' +
            '<input type="checkbox" id="gift-with-purchase-rebuy" name="gift-with-purchase-rebuy" value="Gift with Purchase">' +
            '<span>Add Note & Wrapping</span>' +
          '</div>' +
        '</label>' +
      '</div>' +
      '<div class="rebuy-cart__gift-variants">' +
        '<div class="rebuy-cart__gift-variants-container">' +
          '<div class="rebuy-cart__gift-variants-content">' +
            '<div class="rebuy-cart__gift-images">' +
              '<img src="https://cdn.shopify.com/s/files/1/0795/0887/files/gift_3408658b-c6c3-4614-b0c9-59779b47d6ce.jpg">' +
            '</div>' +
            '<div class="rebuy-cart__gift-notes">' +
              '<label for="notes-gift-wrapping">Notes</label>' +
              '<textarea id="notes-gift-wrapping" name="properties[Note]" placeholder="Optional..."></textarea>' +
            '</div>' +
          '</div>' +
          '<button id="add-gift-rebuy">Add Wrapping & Note</button>' +
        '</div>' +
      '</div>' +
    '</div>'
  );
};

$(document).on('change', '#gift-with-purchase-rebuy', function (){
  if ($(this).is(":checked")) {
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideDown();
  } else {
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideUp();
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping').val('');
  };
});

$(document).on('click', '#add-gift-rebuy', function (){  
  var data = {
    "id": 44636470804654,
    "quantity": 1,
    "properties": {
      "Note": $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping').val()
    }
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideUp();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping').val('');
      $('#gift-with-purchase-rebuy').prop("checked", false);
      $('.rebuy-cart__flyout-gift .message-success-gift').show();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-container').hide();
    }
  });
});

function wrapping(qty,gift){

    var $quantity = qty;
    var $gift = gift;

    function $giftPurchase(productId){
      return productId.product_id === 8203524898990;
    };
  
    var $validationGift = $gift.find($giftPurchase);

    if($quantity > 0){
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift').show();
    } else {
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift').hide();
    };

    if ($validationGift !== undefined) {
      if($quantity > 1){
        $('.rebuy-cart__flyout-gift .message-success-gift').show();
        $('.rebuy-cart__flyout-gift .rebuy-cart__gift-container').hide();
        $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').hide();
        var $qtyGift = $validationGift.quantity;
        if($qtyGift > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              44636470804654: 0
            }
          });
        };
      } else {
        jQuery.post('/cart/update.js', {
          updates: {
            44636470804654: 0
          }
        });
      };
    } else {
      $('.rebuy-cart__flyout-gift .message-success-gift').hide();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-container').show();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').hide();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping').val('');
      $('#gift-with-purchase-rebuy').prop("checked", false);
    };

};


/* Script Free Mezuzah */

function FreeMezuzah(qty,products){

    var $product = products;

    function $productsPurchase(productId){
      return productId.product_id === 8137443377326;
    };
  
    var $validationProduct = $product.find($productsPurchase);

    if ($validationProduct !== undefined) {
 
        var $qtyProduct = $validationProduct.quantity;
        if($qtyProduct > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              44385025327278: 1
            }
          });
        };

    };

};

/* Script Message Donation */

function renderDonation(){
  $('.rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal').after(`
    <p class="rebuy-cart__flyout-donation">
      <span class="heading-donation">10% of online sales will be donated to help Israel:</span>
      <span>In this purchase, you are donating <b></b></span>
    </p>
  `);
};


function donation(total){
  let donation = total * 0.1;
  let formattedDonation = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(donation / 100);
  $('.rebuy-cart__flyout-donation b').text(formattedDonation);
};


/* Script Insurance */

function $renderInsurance(){
  $('.rebuy-cart__flyout-apps').prepend( 
    '<section class="insurance-personalized">' +
        '<div class="insurance-personalized__container">' +
            '<div class="logo">' +
                '<svg version="1.1" id="icon-svg-insure" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 185 200" style="enable-background:new 0 0 185 200;" xml:space="preserve"><g><path class="st0" d="M92.4,200c-30.7-13.9-86.2-56.3-87.4-88.9L1.8,26.6C1.8,26.6,44.1,0,92.4,0s90.9,26.6,90.9,26.6l-3.4,84.5C178.6,143.7,123.3,186.1,92.4,200z M16.6,34.4l2.9,76.2c1,25.3,49.7,60.9,72.8,73.3V14.4c-19,0-38.2,4.6-55.8,11.2C30,28.3,23,31.2,16.6,34.4z M92.4,190.7c26.3-12.9,78.2-51.4,79.2-79.9l3.2-79.7C151.3,17.5,118.4,8.3,92.4,8.3c-19.7,0-39.7,4.6-58,11.7c-6.8,2.4-17.1,6.6-24.1,11l2.9,79.9C14.4,139.3,66.1,177.8,92.4,190.7z"/></g></svg>' +
            '</div>' +
            '<div class="message">' +
                '<h5>Protect your Package</h5>' +
                '<p>Coverage for loss, theft, or transit damage, with added free return benefits.</p>' +
            '</div>' +
            '<div class="button-price">' +
                '<label class="switch">' +
                    '<input id="insurange-rebuy" type="checkbox">' +
                    '<span class="slider round"></span>' +
                '</label>' +
                '<p class="price">$10.00</p>' +
            '</div>' +
        '</div>' +
    '</section>'
  );
};

function $insurance(totalPrice,arrayProducts){
  
   var $total_price = totalPrice;
   var $array_products = arrayProducts;

    function $findInsurange(id) {
      return id.product_id === 8186851033262;
    };

    var $protectPackage = $array_products.find($findInsurange);

    if($protectPackage === undefined){

      if ($total_price > 1000) {

        var currentDate = new Date().toDateString();
        var cookieName = 'insurangeAdd_' + currentDate;
        console.log(cookieName);
      
        if (document.cookie.indexOf(cookieName) === -1) {
          var data = {
            "id": 44584523858094,
            "quantity": 1
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
              $('#insurange-rebuy').prop('checked', true);
            }
          });
          
          var expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 1);
          document.cookie = cookieName + '=1; expires=' + expireDate.toUTCString() + '; path=/';
          
        } else {

          $('#insurange-rebuy').prop('checked', false);
          
        };
        
      } else {

        $('#insurange-rebuy').prop('checked', false);
        
      };

    } else {
      
      if ($total_price > 1000) {

        var $qty_product = $protectPackage.quantity;

        if($qty_product > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              44584523858094: 1
            }
          });
        };
        $('#insurange-rebuy').prop('checked', true);
        
      } else {
        
        $('#insurange-rebuy').prop('checked', false);
        jQuery.post('/cart/update.js', {
          updates: {
            44584523858094: 0
          }
        });
      };
      
    };

};

$(document).on('change', '#insurange-rebuy', function() {
  
  if ($(this).is(':checked')){
     var data = {
      "id": 44584523858094,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        console.log('Add Protect Package');
      }
    });
  } else {
    jQuery.post('/cart/update.js', {
      updates: {
        44584523858094: 0
      }
    });
  };
});



/* Script Progress Bar */

function $renderContainer(){

  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

    '<section class="progress-bar__section">' +

      '<div class="progress-bar__section--container">' +

        '<div class="progress-bar__header">' +
            '<h6>Free Dough Cloth on Orders Over +$75</h6>' +
        '</div>' +

        /*
        '<div class="container-form-offert">' +
          '<div class="container-form-selector">' +
            '<p class="container-form-selector__title">Select a design:</p>'+
            '<form class="container-variants">'+
              '<div class="variants"><input type="radio" name="vaiants-cart" id="variant-one" value="44211503300782" class="active-radio" checked><label for="variant-one">Mitzvah</label></div>'+
              '<div class="variants"><input type="radio" name="vaiants-cart" id="variant-two" value="44211503333550"><label for="variant-two">Faith</label></div>'+
              '<div class="variants"><input type="radio" name="vaiants-cart" id="variant-three" value="44211503366318"><label for="variant-three">Intention</label></div>'+
            '</form>'+
            '<button class="add-product-to-cart">ADD YOUR FAVE!</button>'+
          '</div>' +
        '</div>' +
        */

        '<div class="progress-bar__line">' +

            '<div class="progress-bar__container progress-bar__container--one">' +
                '<div id="progress-bar__tier-one" class="progress-bar__bar"></div>' +
            '</div>' +
            '<div class="progress-bar__item progress-bar__item--one">' +
                '<div class="progress-container">' +
                    '<svg class="progress-svg" viewBox="0 0 100 100">' +
                        '<circle class="progress-background" cx="50" cy="50" r="45"></circle>' +
                        '<circle class="progress-bar" id="progress--tier-one" cx="50" cy="50" r="45"></circle>' +
                    '</svg>' +
                    '<div class="progress-bar__imagen">' +
                        '<img src="https://cdn.shopify.com/s/files/1/0795/0887/files/image-cloth-unit-v2_x65.png">' +
                    '</div>' +
                '</div>' +
                '<div class="progress-attributes">' +
                    '<p class="progress-attributes__base progress-attributes__base--mini-text">$75</p>' +
                    '<p class="progress-attributes__title">Free dough cloth</p>' +
                '</div>' +
            '</div>' +


            '<div class="progress-bar__container progress-bar__container--two">' +
                '<div id="progress-bar__tier-two" class="progress-bar__bar"></div>' +
            '</div>' +
            '<div class="progress-bar__item progress-bar__item--two">' +
                '<div class="progress-container">' +
                    '<svg class="progress-svg" viewBox="0 0 100 100">' +
                        '<circle class="progress-background" cx="50" cy="50" r="45"></circle>' +
                        '<circle class="progress-bar" id="progress--tier-two" cx="50" cy="50" r="45"></circle>' +
                    '</svg>' +
                    '<div class="progress-bar__imagen">' +
                        '<img src="https://cdn.shopify.com/s/files/1/0795/0887/files/image-cloth-set-v2_x65.png">' +
                    '</div>' +
                '</div>' +
                '<div class="progress-attributes">' +
                    '<p class="progress-attributes__base">$350</p>' +
                    '<p class="progress-attributes__title">Upgrade to set of 3</p>' +
                '</div>' +
            '</div>' +

        '</div>'+

        '<div class="disclaimers-section">' +
          '<p>* Only available while supplies last.</p>' +
          '<p>** Only applicable to retail customers.</p>' +
        '</div>' +

      '</div>' +

    '</section>'
  
  );
  
};

function $progressBar(totalPrice,arrayProducts){

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    var $price_promotion_one = 7500 - $total_price; var $promotion_one = ($price_promotion_one /= Math.pow(10, 2)).toFixed(2); var $porcentPromotionOne = ((75.0 - $promotion_one) / 75.0 * 100);
    var $price_promotion_two = 35000 - $total_price; var $promotion_two = ($price_promotion_two /= Math.pow(10, 2)).toFixed(2); var $porcentPromotionTwo = ((350.00 - $promotion_two) / 350.00 * 100);

    function $productOne(productId){return productId.product_id === 8074064593070;};var $validationProductOne = $array_products.find($productOne);
    function $productTwo(productId){return productId.product_id === 8074082975918;};var $validationProductTwo = $array_products.find($productTwo);

    if($validationProductOne !== undefined){
      if($total_price <= 7499){
        jQuery.post('/cart/update.js', {
            updates: {
              44211503300782: 0,
              44211503333550: 0,
              44211503366318: 0,
              45765101420718: 0
            }
        });
      } else if($total_price >= 7500 && $total_price <= 34999){
        var $qtyProductOne = $validationProductOne.quantity;
        if($qtyProductOne > 1){
          jQuery.post('/cart/update.js', {
          updates: {
                44211503300782: 0,
                44211503333550: 0,
                44211503366318: 0,
                45765101420718: 0
              }
          });
        };
      } else if($total_price >= 35000){
        jQuery.post('/cart/update.js', {
            updates: {
              44211503300782: 0,
              44211503333550: 0,
              44211503366318: 0,
              45765101420718: 0
            }
        });
      };
    };

  
    if($validationProductTwo !== undefined){

      if($total_price <= 34999){

        jQuery.post('/cart/update.js', {
            updates: {
              44211573653678: 0
            }
        });
        
      } else if($total_price >= 35000){

        var $qtyProductTwo = $validationProductTwo.quantity;
        if($qtyProductTwo > 1){
          jQuery.post('/cart/update.js', {
              updates: {
                44211573653678: 0
              }
          });
        };
        
      };
      
    };

    if($total_price <= 0){

      // $('.rebuy-cart__flyout-body .progress-bar__section .container-form-offert').slideUp();
      
      const $tierOne = $('#progress--tier-one'); const $circumferenceTierOne = 2 * Math.PI * 45; const $offsetTierOne = $circumferenceTierOne - (0 / 100) * $circumferenceTierOne; $tierOne.stop().animate({ 'stroke-dashoffset': $offsetTierOne }, 500);
      const $tierTwo = $('#progress--tier-two'); const $circumferenceTierTwo = 2 * Math.PI * 45; const $offsetTierTwo = $circumferenceTierTwo - (0 / 100) * $circumferenceTierTwo; $tierTwo.stop().animate({ 'stroke-dashoffset': $offsetTierTwo }, 500);

      $("#progress-bar__tier-one").animate({width: "0%",}, 500);
      $("#progress-bar__tier-two").animate({width: "0%",}, 500);

      $('.progress-bar__header').replaceWith(
        '<div class="progress-bar__header">'+
          '<h6>Free Dough Cloth on Orders Over +$75</h6>'+
        '</div>'
      );
      
    } else if($total_price >= 1 && $total_price <= 7499){

      // $('.rebuy-cart__flyout-body .progress-bar__section .container-form-offert').slideUp();
      
      const $tierOne = $('#progress--tier-one'); const $circumferenceTierOne = 2 * Math.PI * 45; const $offsetTierOne = $circumferenceTierOne - ($porcentPromotionOne / 100) * $circumferenceTierOne; $tierOne.stop().animate({ 'stroke-dashoffset': $offsetTierOne }, 500);
      const $tierTwo = $('#progress--tier-two'); const $circumferenceTierTwo = 2 * Math.PI * 45; const $offsetTierTwo = $circumferenceTierTwo - (0 / 100) * $circumferenceTierTwo; $tierTwo.stop().animate({ 'stroke-dashoffset': $offsetTierTwo }, 500);

      $("#progress-bar__tier-one").animate({width: "100%",}, 500);
      $("#progress-bar__tier-two").animate({width: "0%",}, 500);

      $('.progress-bar__header').replaceWith(
        '<div class="progress-bar__header">'+
          '<h6>You need <b>$' + $promotion_one + '</b> to get dough cloth</h6>'+
        '</div>'
      );
      
    } else if($total_price >= 7500 && $total_price <= 34999){

      // if ($validationProductOne === undefined){ $('.rebuy-cart__flyout-body .progress-bar__section .container-form-offert').slideDown(); } else { $('.rebuy-cart__flyout-body .progress-bar__section .container-form-offert').slideUp();};
      
      const $tierOne = $('#progress--tier-one'); const $circumferenceTierOne = 2 * Math.PI * 45; const $offsetTierOne = $circumferenceTierOne - (100 / 100) * $circumferenceTierOne; $tierOne.stop().animate({ 'stroke-dashoffset': $offsetTierOne }, 500);
      const $tierTwo = $('#progress--tier-two'); const $circumferenceTierTwo = 2 * Math.PI * 45; const $offsetTierTwo = $circumferenceTierTwo - ($porcentPromotionTwo / 100) * $circumferenceTierTwo; $tierTwo.stop().animate({ 'stroke-dashoffset': $offsetTierTwo }, 500);

      $("#progress-bar__tier-one").animate({width: "100%",}, 500);
      $("#progress-bar__tier-two").animate({width: "100%",}, 500);

      if ($validationProductOne === undefined){
        
        var $addProductOne = { "id": 45765101420718, "quantity": 1 }; jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: $addProductOne, dataType: 'json', success: function() { console.log('45765101420718: Added'); } }); 
        $('.progress-bar__header').replaceWith(
          '<div class="progress-bar__header">'+
            '<h6>You scored a free challah dough cloth</h6>'+
            '<p>You need <b>$' + $promotion_two + '</b> to upgrade to set of 3</p>' +
          '</div>'
        );
        
      } else {

        $('.progress-bar__header').replaceWith(
          '<div class="progress-bar__header">'+
            '<h6>You unlocked dough cloth</h6>'+
            '<p>You need <b>$' + $promotion_two + '</b> to upgrade to set of 3</p>' +
          '</div>'
        );
        
      };

    } else if($total_price >= 35000){

      // $('.rebuy-cart__flyout-body .progress-bar__section .container-form-offert').slideUp();
      
      if ($validationProductTwo === undefined){ var $addProductTwo = { "id": 44211573653678, "quantity": 1 }; jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: $addProductTwo, dataType: 'json', success: function() { console.log('44211573653678: Added'); } }); };
      const $tierOne = $('#progress--tier-one'); const $circumferenceTierOne = 2 * Math.PI * 45; const $offsetTierOne = $circumferenceTierOne - (100 / 100) * $circumferenceTierOne; $tierOne.stop().animate({ 'stroke-dashoffset': $offsetTierOne }, 500);
      const $tierTwo = $('#progress--tier-two'); const $circumferenceTierTwo = 2 * Math.PI * 45; const $offsetTierTwo = $circumferenceTierTwo - (100 / 100) * $circumferenceTierTwo; $tierTwo.stop().animate({ 'stroke-dashoffset': $offsetTierTwo }, 500);

      $("#progress-bar__tier-one").animate({width: "100%",}, 500);
      $("#progress-bar__tier-two").animate({width: "100%",}, 500);

      $('.progress-bar__header').replaceWith(
        '<div class="progress-bar__header">'+
          '<h6>You unlocked dough cloth set of 3</h6>'+
        '</div>'
      );
      
    };

};

$(document).on('click', '.rebuy-cart__flyout-body .container-form-offert form.container-variants input', function (){
  $('.rebuy-cart__flyout-body .container-form-offert form.container-variants input').removeClass('active-radio');
  $(this).addClass('active-radio');
  $(this).is(':checked');
});

$(document).on('click', '.rebuy-cart__flyout-body .container-form-offert button.add-product-to-cart', function() { 
  var $selectProduct = $('.rebuy-cart__flyout-body .container-form-offert form.container-variants input:checked').val();
  var $dataAdd = {
    "id": $selectProduct,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $dataAdd,
    dataType: 'json',
    success: function() { 
      console.log('Add Product Offer');
    }
  });
});



// Function IP Client.

function messageIP(){
  $('#rebuy-cart .rebuy-cart__flyout-body .rebuy-cart__flyout-content').prepend(`
    <div class="messageIP">
      <div class="messageIP__container">
        <p>
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>Please be advised you are responsible for international customs and duties.</span>
        </p>
      </div>
    </div>
  `);
};

async function getGeoLocation() {
  try {
    const response = await fetch('https://ipinfo.io?token=39f4fb9059ca63');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching geolocation data:', error);
    return null;
  }
}

document.addEventListener('rebuy:smartcart.ready', async function(event) {
  const geoData = await getGeoLocation();
  if (geoData && geoData.country !== 'US') {
    messageIP();
  }
});







/* Script Events Rebuy */

document.addEventListener('rebuy:smartcart.ready', function(event){
  var qty = event.detail.smartcart.cart.item_count;
  var products = event.detail.smartcart.cart.items;
  var total = event.detail.smartcart.cart.total_price;

  // $renderContainer();
  // $progressBar(total,products);
  
  cartReady();
  FreeMezuzah(qty,products);

  $renderInsurance();
  $insurance(total,products);

  /*
  renderDonation();
  donation(total);*/

  giftWrapping();
  wrapping(qty,products);

  if (qty > 0){
    $('#rebuy-cart .rebuy-cart__flyout-note').show();
  } else {
    $('#rebuy-cart .rebuy-cart__flyout-note').hide();
  };
  
});

document.addEventListener('rebuy:cart.change', function(event){
  var qty = event.detail.cart.cart.item_count;
  var products = event.detail.cart.cart.items;
  var total = event.detail.cart.cart.total_price;
  
  $('.open-cart-rebuy .cart-count-bubble span').text(qty);
  FreeMezuzah(qty,products);

  var $containerInsurance = $('.rebuy-cart__flyout-apps .insurance-personalized');
  if ($containerInsurance.length > 0) {
    $insurance(total,products);
  };

  /*
  var $containerDonation = $('.rebuy-cart__flyout-footer .rebuy-cart__flyout-donation');
  if ($containerDonation.length > 0) {
    donation(total);
  };*/
  
  var $containerGift = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift');
  if ($containerGift.length > 0) {
    wrapping(qty,products);
  }; 

  var $containerBar = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .progress-bar__section');
  if ($containerBar.length > 0) {
    // $progressBar(total,products);
  };

  if (qty > 0){
    $('#rebuy-cart .rebuy-cart__flyout-note').show();
  } else {
    $('#rebuy-cart .rebuy-cart__flyout-note').hide();
  };
  
});